import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'speaker-card',
  templateUrl: './speaker-card.component.html',
  styleUrls: ['./speaker-card.component.css']
})
export class SpeakerCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
